import {
	EmptyFeatureResult,
	patchState,
	SignalStoreFeature,
	signalStoreFeature,
	SignalStoreFeatureResult,
	withMethods
} from '@ngrx/signals';

export type TResetStateMethod<TState extends object> = (include?: (keyof TState)[], exclude?: (keyof TState)[]) => void;

export interface TResetStateFeatureResult<TState extends object> extends SignalStoreFeatureResult {
	methods: {
		resetState: TResetStateMethod<TState>;
	};
}

export const withResetState = <TState extends object>(
	initialState: TState
): SignalStoreFeature<EmptyFeatureResult, TResetStateFeatureResult<TState>> =>
	signalStoreFeature(
		withMethods(store => ({
			resetState: (include: (keyof TState)[] = [], exclude: (keyof TState)[] = []): void => {
				const stateKeys = Object.keys(initialState) as (keyof TState)[];
				const keysToReset =
					include.length > 0 ? include : exclude.length > 0 ? stateKeys.filter(key => !new Set(exclude).has(key)) : stateKeys;
				const patch: Partial<TState> = {};
				for (const key of keysToReset) {
					(patch as Record<keyof TState, TState[keyof TState]>)[key] = initialState[key];
				}
				patchState(store, patch);
			}
		}))
	);
